// extracted by mini-css-extract-plugin
export var blockList = "blocks-module--blockList--1gqFA";
export var moveLeft = "blocks-module--moveLeft--1WZ8I";
export var moveRight = "blocks-module--moveRight--1hIQn";
export var block = "blocks-module--block--31tKK";
export var tryParent = "blocks-module--tryParent--FlSm4";
export var btn = "blocks-module--btn--2H9Mc";